import styled from 'styled-components';
import { BreadcrumbsStyled } from '../BreadcrumbsStyled';
import { rem } from 'polished';

export const BreadcrumbsAP = styled(BreadcrumbsStyled)`
    a {
        color: ${({ theme }) => theme.colors.blue4};
        &:not([tabindex='-1']) {
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
        &:hover {
            color: ${({ theme }) => theme.colors.primary};
        }
    }
    span {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }
    span,
    a {
        font-family: ${({ theme }) => theme.fonts.fontBase};
        font-size: ${rem('10px')};
        color: ${({ theme }) => theme.colors.primaryBlack};
        ::before {
            content: '>';
        }
    }
`;
